import { Injectable } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { SpecialValidators } from 'ish-shared/forms/validators/special-validators';

import { FieldLibraryConfiguration } from './field-library-configuration';

/**
 * Postal code, required by default
 */
@Injectable()
export class PostalCodeConfiguration extends FieldLibraryConfiguration {
  id = 'postalCode';

  getFieldConfig(): FormlyFieldConfig {
    return {
      type: 'ish-text-input-field',
      props: {
        label: 'account.address.postalcode.label',
        required: true,
        maxLength: 35,
      },
      validators: {
        validation: [SpecialValidators.noOnlyWhiteSpaces],
      },
      validation: {
        messages: {
          required: 'account.address.postalcode.error.required',
          noOnlyWhiteSpaces: 'account.address.postalcode.error.required',
        },
      },
    };
  }
}
